import PropTypes from 'prop-types';
import React from 'react';

import styles from './CenteredMapMarker.css';
import PudoIcon from 'common/components/PudoOverlayMarker/PudoIcon';

const iconColor = '#1E88E5';

const CenteredMapMarker = ({type}) => (
  <div className={styles.root}>
    <PudoIcon color={iconColor} pulse={false} type={type} />
  </div>
);

CenteredMapMarker.propTypes = {
  type: PropTypes.oneOf(['pickup', 'dropoff']).isRequired,
};

export default CenteredMapMarker;



// WEBPACK FOOTER //
// ./src/ondemand/components/CenteredMapMarker/CenteredMapMarker.js